export default class CroquisAvariasConstant {
    static CROQUI_VEICULO = (tipoVeiculo) => {
        return [
            {
                tipoVeiculo: tipoVeiculo,
                nome: 'frente',
                imagem: require(`@/assets/tiposVeiculos/${tipoVeiculo}-frente.png`),
            },
            {   
                tipoVeiculo: tipoVeiculo,
                nome: 'verso',
                imagem: require(`@/assets/tiposVeiculos/${tipoVeiculo}-verso.png`),
            }
        ]
    }
}